module.exports = __webpack_public_path__ + "static/media/logo-조아라@2x.be042a33.png";